import React from "react";
import { Modal, Input, Space, Typography, message } from "antd";
import { SendStatus } from './constants';

interface CardKeyModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (cardKeys: string[]) => void;
  sendInfos: any[];
}

const CardKeyModal: React.FC<CardKeyModalProps> = ({
  visible,
  onCancel,
  onOk,
  sendInfos,
}) => {
  const [cardKeys, setCardKeys] = React.useState<string[]>([]);
  const [loading, setLoading] = React.useState(false);

  const unSendCount = sendInfos?.filter(
    (i) => i.isSendShotMsg !== SendStatus.Send
  )?.length;

  React.useEffect(() => {
    if (visible) {
      setCardKeys(new Array(unSendCount).fill(""));
    }
  }, [visible, unSendCount]);

  const handleOk = () => {
    const validKeys = cardKeys.filter((k) => k.trim());
    if (validKeys.length !== unSendCount) {
      return message.error("卡密数量与未发送短信的线索数量不一致");
    }
    setLoading(true);
    onOk(cardKeys.map((k) => k.trim()));
  };

  return (
    <Modal
      title="输入卡密"
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      destroyOnClose
    >
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <Typography.Text type="secondary">
          共 {unSendCount} 条未发送短信，请输入卡密
        </Typography.Text>
        {sendInfos?.map(
          (info, index) =>
            info.isSendShotMsg !== SendStatus.Send && (
              <Space key={info._id} style={{ width: "100%" }}>
                <Typography.Text ellipsis style={{ width: 120 }}>
                  {info.tel}
                </Typography.Text>
                <Input
                  placeholder={`请输入第 ${index + 1} 个卡密`}
                  value={cardKeys[index]}
                  onChange={(e) => {
                    const newKeys = [...cardKeys];
                    newKeys[index] = e.target.value;
                    setCardKeys(newKeys);
                  }}
                  style={{ flex: 1 }}
                />
              </Space>
            )
        )}
      </Space>
    </Modal>
  );
};

export default CardKeyModal;